import React from "react";

function Timer({remaining}) {
    if (!remaining) {
        return null;
    }

    const seconds = Math.floor(remaining % 60000 / 1000);
    const minutes = Math.floor(remaining / 60000) % 60;
    const hours = Math.floor(remaining / 3600000);

    return (
        <span>
            ~{hours.toLocaleString('en-US', {minimumIntegerDigits: 2})}:
            {minutes.toLocaleString('en-US', {minimumIntegerDigits: 2})}:
            {seconds.toLocaleString('en-US', {minimumIntegerDigits: 2})}
        </span>
    )
}

export default Timer;